import React from 'react';
import ProfileImageView from "../ProfileImageView";

type PostAndObservationHeaderProps = {
  photo?: string;
  name: string;
  date: string;
};
const PostAndObservationHeader: React.FC<PostAndObservationHeaderProps> = ({ photo, name, date }) => {
  return (
    <div className="d-flex align-items-center">
      <div className="section-with-img flex-1 pd-r-15">
        <div className="section-img">
          <ProfileImageView
            name={name}
            imageUrl={photo}
            customContainerStyles={"mg-r-10"}
          />
        </div>
        <span className="fs-12 fw-semibold text-black flex-1 pd-l-10">
          {name}
        </span>
      </div>
      <div className="fs-12 text-gray-300">{date}</div>
    </div>
  );
};

export default PostAndObservationHeader;
